import * as constants from '../constants/CONSTANT';

const OpportunityLineItemApi = {
  async fetchByOpportunity(opportunityId) {
    const token = localStorage.getItem('token');

    const response = await fetch(
      `${constants.API_BASE_URL}/api/opportunitylineitem/${opportunityId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    return await response.json();
  },
};

export default OpportunityLineItemApi;
